

<template>
    <div>
		<a-modal
		:width='"60rem"'
		id='main-handhomes'
		title='title'
		v-model='visible'
		@on='handleOk'
		@cancel='handleCancel'
		:footer="null" 
		:dialog-style="{ top: '6vh'}"
		:keyboard='false'
		:maskClosable='false'>
			<div class='main-hand-title'>
				<div style="position: relative;top: .44rem;">{{fundFlag == 1?'基金添加':'基金審核'}}</div>
			</div>
            <div style="display: flex;">
				<!-- :"gland"'-->
				<div class="wland" >基金信息</div>
			</div>
			<div id='tubody-mainsk1'>
                <div id='handitemedit1'>
                    <div class="tabelMoreFzView main-mybody">
                        <div class="tabelMoreFzViewIn">
                            <!-- 1 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">產品編號：</div>
                                    <div style="width: 100%;">
                                        <a-input :class="{'border_red': obj.falg3}" @input="obj.falg3=false" :disabled='!editFund' v-model="form.fund_code"></a-input>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Product Code：</div>
                                    <div style="width: 100%;">
                                        <a-input :class="{'border_red': obj.falg3}" @input="obj.falg3=false" :disabled='!editFund' v-model="form.fund_code"></a-input>
                                    </div>
                                </div>
                            </div>
                            <!-- 2 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">產品名稱：</div>
                                    <div style="width: 100%;">
                                        <a-input :class="{'border_red': obj.falg1}" @input="obj.falg1=false,handleInput(1)" :disabled='!editFund' v-model="form.fund_name_cn"></a-input>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Product Name：</div>
                                    <div style="width: 100%;">
                                        <a-input :class="{'border_red': obj.falg2}" @input="obj.falg2=false,handleInput(2)" :disabled='!editFund' v-model="form.fund_name_en"></a-input>
                                    </div>
                                </div>
                            </div>
                            <!-- 3-1 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">貨幣：</div>
                                    <div style="width: 100%;">
                                        <a-select :class="{'border_red': obj.falg5}" v-model="form.currency" @change="obj.falg5=false"  style="width: 100%;">
                                            <a-select-option v-for="(item,index) in currencyList" :key="index" :value="parseInt(item.value)">{{item.text_cn}}</a-select-option>
                                        </a-select>
                                        <!-- <a-input :disabled='!editFund' v-model="form.company_name_cn"></a-input> -->
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Currency：</div>
                                    <div style="width: 100%;">
                                        <a-select :class="{'border_red': obj.falg5}" v-model="form.currency" @change="obj.falg5=false"  style="width: 100%;">
                                            <a-select-option v-for="(item,index) in currencyList" :key="index" :value="parseInt(item.value)">{{item.text_en}}</a-select-option>
                                        </a-select>
                                        <!-- <a-input :disabled='!editFund' v-model="form.company_name_en"></a-input> -->
                                    </div>
                                </div>
                            </div>
                            <!-- 4 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">發行日期：</div>
                                    <div style="width: 100%;">
                                        <a-date-picker  :class="{'border_red': obj.falg16}" v-model="form.issue_date" @change="formatDate(form.issue_date,1),obj.falg16=false" placeholder=" " :disabled='!editFund' />
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Issue Date：</div>
                                    <div style="width: 100%;">
                                        <a-date-picker :class="{'border_red': obj.falg16}" v-model="form.issue_date" @change="formatDate(form.issue_date,1),obj.falg16=false"  placeholder=" " :disabled='!editFund' />
                                    </div>
                                </div>
                            </div>
                            <!-- 5 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">累積表現：</div>
                                    <div style="width: 100%;">
                                        <a-input v-model="form.cumulative_performance" @blur="blurClick(13)" :disabled='!editFund' type="number" suffix="%"></a-input>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Cumulative Performance：</div>
                                    <div style="width: 100%;">
                                        <a-input v-model="form.cumulative_performance" @blur="blurClick(13)" :disabled='!editFund' type="number" suffix="%"></a-input>
                                    </div>
                                </div>
                            </div>
                            <!-- 6 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">產品類別：</div>
                                    <div style="width: 100%;">
                                        <a-select :class="{'border_red': obj.falg4}" v-model="form.fund_type "  @change="obj.falg4=false" style="width: 100%;">
                                            <a-select-option v-for="(item,index) in jjlxList" :key="index" :value="parseInt(item.value)">{{item.text_cn}}</a-select-option>
                                        </a-select>
                                        <!-- <a-input :disabled='!editFund' v-model="form.company_name_cn"></a-input> -->
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Product Type：</div>
                                    <div style="width: 100%;">
                                        <a-select :class="{'border_red': obj.falg4}" v-model="form.fund_type " @change="obj.falg4=false"  style="width: 100%;">
                                            <a-select-option v-for="(item,index) in jjlxList" :key="index" :value="parseInt(item.value)">{{item.text_en}}</a-select-option>
                                        </a-select>
                                        <!-- <a-input :disabled='!editFund' v-model="form.company_name_en"></a-input> -->
                                    </div>
                                </div>
                            </div>
                            <!-- 7 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">風險評級：</div>
                                    <div style="width: 100%;">
                                        <a-select :class="{'border_red': obj.falg6}" v-model="form.risk_rating" @change="obj.falg6=false" style="width: 100%;">
                                            <a-select-option v-for="(item,index) in riskList" :key="index" :value="parseInt(item.value)">{{item.text_cn}}</a-select-option>
                                        </a-select>
                                        <!-- <a-input :disabled='!editFund' v-model="form.risk_type_cn"></a-input> -->
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Risk Rating：</div>
                                    <div style="width: 100%;">
                                        <a-select :class="{'border_red': obj.falg6}" v-model="form.risk_rating" @change="obj.falg6=false" style="width: 100%;">
                                            <a-select-option v-for="(item,index) in riskList" :key="index" :value="parseInt(item.value)">{{item.text_en}}</a-select-option>
                                        </a-select>
                                        <!-- <a-input :disabled='!editFund' v-model="form.risk_type_en"></a-input> -->
                                    </div>
                                </div>
                            </div>
                            <!-- 8 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">參考價格：</div>
                                    <div style="width: 100%;">
                                        <a-input :class="{'border_red': obj.falg7}" v-model="form.latest_price" @input="obj.falg7=false" @blur="blurClick(1)" @focus="focusClick(1)" @change="moneyClick(1)" :disabled='!editFund' ></a-input>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Indicative Price：</div>
                                    <div style="width: 100%;">
                                        <a-input :class="{'border_red': obj.falg7}" v-model="form.latest_price" @input="obj.falg7=false" @blur="blurClick(1)" @focus="focusClick(1)" @change="moneyClick(1)" :disabled='!editFund'></a-input>
                                    </div>
                                </div>
                            </div>
                            <!-- 9 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">入場費：</div>
                                    <div style="width: 100%;">
                                        <a-input :class="{'border_red': obj.falg8}" v-model="form.initial_amount" @input="obj.falg8=false" @blur="blurClick(2)" @focus="focusClick(2)" @change="moneyClick(2)" :disabled='!editFund' ></a-input>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Admission Amount：</div>
                                    <div style="width: 100%;">
                                        <a-input :class="{'border_red': obj.falg8}" v-model="form.initial_amount" @input="obj.falg8=false" @blur="blurClick(2)" @focus="focusClick(2)" @change="moneyClick(2)" :disabled='!editFund' ></a-input>
                                    </div>
                                </div>
                            </div>
                            <!-- 10 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">後續投資額：</div>
                                    <div style="width: 100%;">
                                        <a-input :class="{'border_red': obj.falg9}" v-model="form.subsequent_investment_amount" @input="obj.falg9=false" @blur="blurClick(3)" @focus="focusClick(3)" @change="moneyClick(3)" :disabled='!editFund' ></a-input>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Sub Investment Amount：</div>
                                    <div style="width: 100%;">
                                        <a-input :class="{'border_red': obj.falg9}" v-model="form.subsequent_investment_amount" @input="obj.falg9=false" @blur="blurClick(3)" @focus="focusClick(3)" @change="moneyClick(3)" :disabled='!editFund' ></a-input>
                                    </div>
                                </div>
                            </div>
                            <!-- 11 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">最低持倉額：</div>
                                    <div style="width: 100%;">
                                        <a-input :class="{'border_red': obj.falg10}" v-model="form.min_holding_amount" @input="obj.falg10=false" @blur="blurClick(4)" @focus="focusClick(4)" @change="moneyClick(4)" :disabled='!editFund' ></a-input>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Min Holding Amount：</div>
                                    <div style="width: 100%;">
                                        <a-input :class="{'border_red': obj.falg10}" v-model="form.min_holding_amount" @input="obj.falg10=false" @blur="blurClick(4)" @focus="focusClick(4)" @change="moneyClick(4)" :disabled='!editFund' ></a-input>
                                    </div>
                                </div>
                            </div>
                            <!-- 12 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">最低贖回額：</div>
                                    <div style="width: 100%;">
                                        <a-input :class="{'border_red': obj.falg11}" v-model="form.min_redemption_amount" @input="obj.falg11=false"  @blur="blurClick(5)" @focus="focusClick(5)" @change="moneyClick(5)"  :disabled='!editFund' ></a-input>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Min Redemption Amount：</div>
                                    <div style="width: 100%;">
                                        <a-input :class="{'border_red': obj.falg11}" v-model="form.min_redemption_amount" @input="obj.falg11=false"  @blur="blurClick(5)" @focus="focusClick(5)" @change="moneyClick(5)"   :disabled='!editFund' ></a-input>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- 13 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">管理費：</div>
                                    <div style="width: 100%;">
                                        <a-input :class="{'border_red': obj.falg15}" v-model="form.management_fee" @blur="blurClick(14)" @input="obj.falg15=false"   :disabled='!editFund'  type="number" suffix="%"></a-input>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Management Fee：</div>
                                    <div style="width: 100%;">
                                        <a-input :class="{'border_red': obj.falg15}" v-model="form.management_fee" @blur="blurClick(14)" @input="obj.falg15=false" :disabled='!editFund'  type="number" suffix="%"></a-input>
                                    </div>
                                </div>
                            </div>
                            <!-- 14 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">股息分派方式：</div>
                                    <div style="width: 100%;">
                                        <a-select :class="{'border_red': obj.falg13}" v-model="form.dividend_distribution_method"  @change="obj.falg13=false" style="width: 100%;">
                                            <a-select-option v-for="(item,index) in dividendList" :key="index" :value="parseInt(item.value)">{{item.text_cn}}</a-select-option>
                                        </a-select>
                                        <!-- <a-input :disabled='!editFund' v-model="form.latest_price_cn"></a-input> -->
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Dividend Option：</div>
                                    <div style="width: 100%;">
                                        <a-select :class="{'border_red': obj.falg13}" v-model="form.dividend_distribution_method" @change="obj.falg13=false" style="width: 100%;">
                                            <a-select-option v-for="(item,index) in dividendList" :key="index" :value="parseInt(item.value)">{{item.text_en}}</a-select-option>
                                        </a-select>
                                        <!-- <a-input :disabled='!editFund' v-model="form.latest_price_en"></a-input> -->
                                    </div>
                                </div>
                            </div>
                            <!-- 15 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">派息頻率：</div>
                                    <div style="width: 100%;">
                                        <a-select :class="{'border_red': obj.falg14}" v-model="form.dividend_frequency"  @change="obj.falg14=false" style="width: 100%;">
                                            <a-select-option v-for="(item,index) in factionalList" :key="index" :value="parseInt(item.value)">{{item.text_cn}}</a-select-option>
                                        </a-select>
                                        <!-- <a-input :disabled='!editFund' v-model="form.latest_price_cn"></a-input> -->
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Dividend Frequency：</div>
                                    <div style="width: 100%;">
                                        <a-select :class="{'border_red': obj.falg14}" v-model="form.dividend_frequency"  @change="obj.falg14=false" style="width: 100%;">
                                            <a-select-option v-for="(item,index) in factionalList" :key="index" :value="parseInt(item.value)">{{item.text_en}}</a-select-option>
                                        </a-select>
                                        <!-- <a-input :disabled='!editFund' v-model="form.latest_price_en"></a-input> -->
                                    </div>
                                </div>
                            </div>
                            <!-- 16 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">複雜投資產品：</div>
                                    <div style="width: 100%;">
                                        <a-select :class="{'border_red': obj.falg12}" v-model="form.complex_product"  @change="obj.falg12=false" style="width: 100%;">
                                            <a-select-option :value="2">是</a-select-option>
                                            <a-select-option :value="1">否</a-select-option>
                                        </a-select>
                                        <!-- <a-input :disabled='!editFund' v-model="form.latest_price_cn"></a-input> -->
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Complex Product：</div>
                                    <div style="width: 100%;">
                                        <a-select :class="{'border_red': obj.falg12}" v-model="form.complex_product" @change="obj.falg12=false" style="width: 100%;">
                                            <a-select-option :value="2">YES</a-select-option>
                                            <a-select-option :value="1">NO</a-select-option>
                                        </a-select>
                                        <!-- <a-input :disabled='!editFund' v-model="form.latest_price_en"></a-input> -->
                                    </div>
                                </div>
                            </div>
                            <!-- 17 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">預計收益年率：</div>
                                    <div style="width: 100%;">
                                        <a-input v-model="form.estimated_coupon_rate" @blur="blurClick(7)" :disabled='!editFund' type="number" suffix="%" ></a-input>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Estimated Coupon Rate：</div>
                                    <div style="width: 100%;">
                                        <a-input v-model="form.estimated_coupon_rate" @blur="blurClick(7)" :disabled='!editFund' type="number" suffix="%" ></a-input>
                                    </div>
                                </div>
                            </div>
                            <!-- 18 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">三年風險收益率：</div>
                                    <div style="width: 100%;">
                                        <a-input v-model="form.three_yrs_risk_return_ratio" @blur="blurClick(8)" :disabled='!editFund' type="number" suffix="%" ></a-input>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">3 Yrs Risk Return Ratio：</div>
                                    <div style="width: 100%;">
                                        <a-input v-model="form.three_yrs_risk_return_ratio" @blur="blurClick(8)" :disabled='!editFund' type="number" suffix="%" ></a-input>
                                    </div>
                                </div>
                            </div>
                            <!-- 19 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">夏普比率：</div>
                                    <div style="width: 100%;">
                                        <a-input v-model="form.sharpe_ratio"  @blur="blurClick(9)" :disabled='!editFund' type="number" suffix="%"></a-input>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Sharpe Ratio：</div>
                                    <div style="width: 100%;">
                                        <a-input v-model="form.sharpe_ratio"  @blur="blurClick(9)" :disabled='!editFund' type="number" suffix="%"></a-input>
                                    </div>
                                </div>
                            </div>
                            <!-- 20 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">近一個月回報：</div>
                                    <div style="width: 100%;">
                                        <a-input v-model="form.last_one_mth_returns" @blur="blurClick(12)" :disabled='!editFund' type="number" suffix="%"></a-input>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Last 1 Mth Returns：</div>
                                    <div style="width: 100%;">
                                        <a-input v-model="form.last_one_mth_returns" @blur="blurClick(12)" :disabled='!editFund' type="number" suffix="%"></a-input>
                                    </div>
                                </div>
                            </div>
                            <!-- 21 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">近三個月回報：</div>
                                    <div style="width: 100%;">
                                        <!-- <a-select v-model="form.risk_type_cn"  style="width: 100%;">
                                            <a-select-option v-for="(item,index) in riskList" :key="index" :value="item.text_cn">{{item.text_cn}}</a-select-option>
                                        </a-select> -->
                                        <a-input v-model="form.last_three_mths_returns"  @blur="blurClick(11)" :disabled='!editFund' type="number" suffix="%"></a-input>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Last 3 Mths Returns：</div>
                                    <div style="width: 100%;">
                                        <!-- <a-select v-model="form.risk_type_cn"  style="width: 100%;">
                                            <a-select-option v-for="(item,index) in riskList" :key="index" :value="item.text_cn">{{item.text_cn}}</a-select-option>
                                        </a-select> -->
                                        <a-input v-model="form.last_three_mths_returns"  @blur="blurClick(11)" :disabled='!editFund' type="number" suffix="%"></a-input>
                                    </div>
                                </div>
                            </div>
                            <!-- 22 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">年初至今回報：</div>
                                    <div style="width: 100%;">
                                        <a-input v-model="form.year_to_date_returns" @blur="blurClick(10)" :disabled='!editFund' type="number" suffix="%"></a-input>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Year-to-Date Returns：</div>
                                    <div style="width: 100%;">
                                        <a-input v-model="form.year_to_date_returns"  @blur="blurClick(10)" :disabled='!editFund' type="number" suffix="%"></a-input>
                                    </div>
                                </div>
                            </div>
                            <!-- 23 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">認購時間：</div>
                                    <div style="width: 100%;">
                                        <a-select v-model="form.subscription_frequency" :class="{'border_red': obj.falg17}" @change="obj.falg17=false" :disabled='!editFund'  style="width: 100%;">
                                            <a-select-option :value="1">每日</a-select-option>
                                            <a-select-option :value="2">每月</a-select-option>
                                            <a-select-option :value="3">每半年</a-select-option>
                                            <a-select-option :value="4">每年</a-select-option>
                                        </a-select>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Subscription Frequency：</div>
                                    <div style="width: 100%;">
                                        <a-select v-model="form.subscription_frequency" :class="{'border_red': obj.falg17}" @change="obj.falg17=false" :disabled='!editFund'  style="width: 100%;">
                                            <a-select-option :value="1">Per Day</a-select-option>
                                            <a-select-option :value="2">Per Month</a-select-option>
                                            <a-select-option :value="3">Per Semi-Annum</a-select-option>
                                            <a-select-option :value="4">Per Annum</a-select-option>
                                        </a-select>
                                    </div>
                                </div>
                            </div>
                            <!-- 24 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">證監會認可產品：</div>
                                    <div style="width: 100%;">
                                        <a-select v-model="form.authorized_product" :class="{'border_red': obj.falg18}" @change="obj.falg18=false" :disabled='!editFund'  style="width: 100%;">
                                            <a-select-option :value="2">是</a-select-option>
                                            <a-select-option :value="1">否</a-select-option>
                                        </a-select>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">SFC Authorized Product：</div>
                                    <div style="width: 100%;">
                                        <a-select v-model="form.authorized_product" :class="{'border_red': obj.falg18}" @change="obj.falg18=false" :disabled='!editFund'  style="width: 100%;">
                                            <a-select-option :value="2">YES</a-select-option>
                                            <a-select-option :value="1">NO</a-select-option>
                                        </a-select>
                                    </div>
                                </div>
                            </div>
                            <!-- 25 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">估值日期：</div>
                                    <div style="width: 100%;">
                                        <a-date-picker  :class="{'border_red': obj.falg19}" v-model="form.valuation_date" @change="formatDate(form.valuation_date,3),obj.falg19=false" placeholder=" " :disabled='!editFund' />
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Valuation Date：</div>
                                    <div style="width: 100%;">
                                        <a-date-picker :class="{'border_red': obj.falg19}" v-model="form.valuation_date" @change="formatDate(form.valuation_date,3),obj.falg19=false"  placeholder=" " :disabled='!editFund' />
                                    </div>
                                </div>
                            </div>
                            <!-- 26 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">基金簡報：</div>
                                    <div style="width: 100%;">
                                        <a-input :disabled='!editFund'  v-model="form.fund_factsheet"></a-input>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Fund Factsheet：</div>
                                    <div style="width: 100%;">
                                        <a-input :disabled='!editFund'  v-model="form.fund_factsheet_en"></a-input>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class='warp_daochu' v-if="fundFlag == 2 && firstLevelFund">
                        <div style="padding-left: .5rem;width:34.5rem">
                            <a-textarea v-model='remark' placeholder=" " allow-clear style='width: 100%;' />
                        </div>
                        <div style="padding: .35rem 0;" >
                            <button class='btn1' @click='shTgEvent(2)' style="background-color: #ed4849;">審核拒絕</button>
                            <button class='btn1 btnx' @click='shTgEvent(1)'>審核通過</button>
                        </div>
                    </div>
                    <div class='warp_daochu' v-else>
                        <div style="padding: .35rem 0;margin-left: auto;">
                            <button class='btn1 btnx'  @click='handokfn(1)'>保存</button>
                            <button class='btn1 ' style="background-color: #f48d28;" @click='handokfn(2)'>提交</button>
                        </div>
                    </div>
                </div>
			</div>
		</a-modal>
	</div>

</template>

<script>
	import https from '@/plugins/http.js';
	import apiUrl from '@/assets/api.js';
	import App from '@/assets/app.js';

	export default {
		props: ['fundFlag','param'],
		data() {
			return {
                obj:{
                    falg1:false,
                    falg2:false,
                    falg3:false,
                    falg4:false,
                    falg5:false,
                    falg6:false,
                    falg7:false,
                    falg8:false,
                    falg9:false,
                    falg10:false,
                    falg11:false,
                    falg12:false,
                    falg13:false,
                    falg14:false,
                    falg15:false,
                    falg16:false,
                    falg17:false,
                    falg18:false,
                    falg19:false,
                },
                form:{
                    fund_name_cn:'',                
                    fund_name_en:'',                  
                    fund_code:'',                  
                    fund_type:'',                   
                    currency:'',                    
                    risk_rating:'',               
                    latest_price:'',                  
                    initial_amount:'',                 
                    subsequent_investment_amount:'',                
                    min_holding_amount:'',                 
                    min_redemption_amount:'',                
                    complex_product:'',                 
                    dividend_distribution_method:'',                    
                    dividend_frequency:'',                 
                    estimated_coupon_rate:'',                 
                    three_yrs_risk_return_ratio:'',                
                    sharpe_ratio:'',                    
                    year_to_date_returns:'',                   
                    last_three_mths_returns:'',                
                    last_one_mth_returns:'',                 
                    cumulative_performance:'',                 
                    management_fee:'',                
                    issue_date:'',   
                    fund_factsheet:'',   
                    fund_factsheet_en:'',   

                    subscription_frequency:'',   
                    authorized_product:'',   
                    valuation_date:'',   
                },
                factionalList:[
                    {
                        text_cn:'每月',
                        text_en:'Monthly',
                        value:'1'
                    },
                    {
                        text_cn:'每季',
                        text_en:'Quarterly',
                        value:'2'
                    },
                    {
                        text_cn:'半年度',
                        text_en:'Semi-Annually',
                        value:'3'
                    },
                    {
                        text_cn:'年度',
                        text_en:'Annually',
                        value:'4'
                    },
                    {
                        text_cn:'非固定',
                        text_en:'Incidental',
                        value:'5'
                    },
                ],
                dividendList:[
                    {
                        text_cn:'股息再投資',
                        text_en:'Reinvest',
                        value:'1'
                    },
                    {
                        text_cn:'現金',
                        text_en:'Cash',
                        value:'2'
                    },
                    {
                        text_cn:'視乎帳戶股息選擇',
                        text_en:'Depends on default option',
                        value:'3'
                    },
                ],
                currencyList:[
                    {
                        text_cn:'港幣',
                        text_en:'HKD',
                        value:'1'
                    },
                    {
                        text_cn:'美元',
                        text_en:'USD',
                        value:'2'
                    },
                    {
                        text_cn:'人民幣',
                        text_en:'CNY',
                        value:'3'
                    },
                    {
                        text_cn:'日元',
                        text_en:'JPY',
                        value:'4'
                    },
                    {
                        text_cn:'澳元',
                        text_en:'AUD',
                        value:'5'
                    },
                    {
                        text_cn:'新加坡元',
                        text_en:'SGD',
                        value:'6'
                    },
                    {
                        text_cn:'台幣',
                        text_en:'TWD',
                        value:'7'
                    },
                    {
                        text_cn:'馬幣',
                        text_en:'MYR',
                        value:'8'
                    },
                ],
                riskList:[
                    {
                        text_cn:'最低風險',
                        text_en:'Very Low',
                        value:'1'
                    },
                    {
                        text_cn:'較低風險',
                        text_en:'Comparatively Low',
                        value:'2'
                    },
                    {
                        text_cn:'中等風險',
                        text_en:'Medium',
                        value:'3'
                    },
                    {
                        text_cn:'較高風險',
                        text_en:'Comparatively High',
                        value:'4'
                    },
                    {
                        text_cn:'最高風險',
                        text_en:'Very High',
                        value:'5'
                    },
                ],
                jjlxList:[
                    {
                        text_cn:'混合資產基金',
                        text_en:'Mutual Fund',
                        value:'1'
                    },
                    {
                        text_cn:'基金中的基金',
                        text_en:'Fund of Funds',
                        value:'2'
                    },
                    {
                        text_cn:'貨幣市場基金',
                        text_en:'Money Market Funds',
                        value:'3'
                    },
                    {
                        text_cn:'均衡基金',
                        text_en:'Balanced Fund',
                        value:'4'
                    },
                    {
                        text_cn:'定息基金',
                        text_en:'Fixed Income Fund',
                        value:'5'
                    },
                    {
                        text_cn:'股票基金',
                        text_en:'Equity Fund',
                        value:'6'
                    },
                    {
                        text_cn:'指數基金',
                        text_en:'Index Fund',
                        value:'7'
                    },
                    {
                        text_cn:'另類基金',
                        text_en:'Alternative Investment Fund',
                        value:'8'
                    }
                ],
                remark:'',
                visible:true,
                bjFlag : false,
                firstLevelFund: this.$store.state.rolesdata.indexOf('firstLevelFund') >= 0,
				editFund: this.$store.state.rolesdata.indexOf('editFund') >= 0,
			}
		},
		mounted() {
            this.getdata()
		},
		methods: {
            focusClick(val){
                if (val == 1) {
                    if (this.form.latest_price) {
                        this.form.latest_price = this.form.latest_price.replace(/,/g, '');
                    }
                }
                if (val == 2) {
                    if (this.form.initial_amount) {
                        this.form.initial_amount = this.form.initial_amount.replace(/,/g, '');
                    }
                }
                if (val == 3) {
                    if (this.form.subsequent_investment_amount) {
                        this.form.subsequent_investment_amount = this.form.subsequent_investment_amount.replace(/,/g, '');
                    }
                }
                if (val == 4) {
                    if (this.form.min_holding_amount) {
                        this.form.min_holding_amount = this.form.min_holding_amount.replace(/,/g, '');
                    }
                }
                if (val == 5) {
                    if (this.form.min_redemption_amount) {
                        this.form.min_redemption_amount = this.form.min_redemption_amount.replace(/,/g, '');
                    }
                }
                // if (val == 6) {
                //     if (this.form.management_fee) {
                //         this.form.management_fee = this.form.management_fee.replace(/,/g, '');
                //     }
                // }
            },
            moneyClick(val){
                if (val == 1) {
                    if (this.form.latest_price) {
                        this.form.latest_price = this.form.latest_price.match(/\d+\.?\d{0,2}/,'')
                    }
                }
                if (val == 2) {
                    if (this.form.initial_amount) {
                        this.form.initial_amount = this.form.initial_amount.match(/\d+\.?\d{0,2}/,'')
                    }
                }
                if (val == 3) {
                    if (this.form.subsequent_investment_amount) {
                        this.form.subsequent_investment_amount = this.form.subsequent_investment_amount.match(/\d+\.?\d{0,2}/,'')
                    }
                }
                if (val == 4) {
                    if (this.form.min_holding_amount) {
                        this.form.min_holding_amount = this.form.min_holding_amount.match(/\d+\.?\d{0,2}/,'')
                    }
                }
                if (val == 5) {
                    if (this.form.min_redemption_amount) {
                        this.form.min_redemption_amount = this.form.min_redemption_amount.match(/\d+\.?\d{0,2}/,'')
                    }
                }
                // if (val == 6) {
                //     if (this.form.management_fee) {
                //         this.form.management_fee = this.form.management_fee.match(/\d+\.?\d{0,2}/,'')
                //     }
                // }
            },
            blurClick(val){
                if (val == 1) {
                    this.form.latest_price =  this.getArea(Number(this.form.latest_price).toFixed(2))
                }
                if (val == 2) {
                    this.form.initial_amount =  this.getArea(Number(this.form.initial_amount).toFixed(2))
                }
                if (val == 3) {
                    this.form.subsequent_investment_amount =  this.getArea(Number(this.form.subsequent_investment_amount).toFixed(2))
                }
                if (val == 4) {
                    this.form.min_holding_amount =  this.getArea(Number(this.form.min_holding_amount).toFixed(2))
                }
                if (val == 5) {
                    this.form.min_redemption_amount =  this.getArea(Number(this.form.min_redemption_amount).toFixed(2))
                }

                if (val == 7) {
                    this.form.estimated_coupon_rate =  Number(this.form.estimated_coupon_rate).toFixed(2)
                }
                if (val == 8) {
                    this.form.three_yrs_risk_return_ratio =  Number(this.form.three_yrs_risk_return_ratio).toFixed(2)
                }
                if (val == 9) {
                    this.form.sharpe_ratio =  Number(this.form.sharpe_ratio).toFixed(2)
                }
                if (val == 10) {
                    this.form.year_to_date_returns =  Number(this.form.year_to_date_returns).toFixed(2)
                }
                if (val == 11) {
                    this.form.last_three_mths_returns =  Number(this.form.last_three_mths_returns).toFixed(2)
                }
                if (val == 12) {
                    this.form.last_one_mth_returns =  Number(this.form.last_one_mth_returns).toFixed(2)
                }
                if (val == 13) {
                    this.form.cumulative_performance =  Number(this.form.cumulative_performance).toFixed(2)
                }
                if (val == 14) {
                    this.form.management_fee =  Number(this.form.management_fee).toFixed(2)
                }
               
                // if (val == 6) {
                //     this.form.management_fee =  this.getArea(Number(this.form.management_fee).toFixed(2))
                // }
            },
            getArea(area) {
                return String(area).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            },
            handleInput(val){
              
                if(val == 2 ){
                    this.form.fund_name_en = this.form.fund_name_en.replace(/[\u4e00-\u9fa5]/g, '');
                }
            },
            formatDate(valTime,ind) {
                // const date = new Date(valTime);
                // const formattedDate = date.toISOString().split('T')[0];
                // console.log(this.form.issue_date );
                const date = new Date(valTime);
                let year = date.getFullYear();
                let month = date.getMonth() + 1; // 月份是从 0 开始的，所以需要加1
                let day = date.getDate();
                let formattedDate = year + '-' + (month < 10 ? '0' : '') + month + '-' + (day < 10 ? '0' : '') + day;
                if (ind == 1) {
                    this.form.issue_date = formattedDate;
                }
                // if (ind == 2) {
                //     this.form.subscription_frequency = formattedDate;
                // }
                if (ind == 3) {
                    this.form.valuation_date = formattedDate;
                }
            },
            // formattedDate() {
            //     const parts = this.originalDate.split("/");
            //     const newDate = parts[2] + "-" + parts[1] + "-" + parts[0];
            //     return newDate;
            // },
            getdata(){
                if (this.fundFlag == 1) {
                    return
                }
                this.$ajax({
                    method: 'post',
                    url: this.$api.getFundById,
                    data: {
                        type:this.param.type,
                        id:this.param.id,
                }
                }).then(res => {
                    if (res.data.qmiscode === 1000) {
                        this.form = res.data;
                        const parts = res.data.issue_date.split("/");
                        const newDate = parts[2] + "-" + parts[1] + "-" + parts[0];
                        this.form.issue_date = newDate
                        this.form.min_redemption_amount = Number(res.data.min_redemption_amount).toFixed(2)
                        this.form.management_fee = Number(res.data.management_fee).toFixed(2)

                        // 123
                    } else {
                        this.$message.warning(res.data.qmismsg)
                    }
                })
            },
            shTgEvent(val){
                // return
                if (val == 2 && !this.remark) {
                    this.$message.warning('請填寫備註信息')
                    return
                }else{
                    if (!this.remark) {
                        this.remark = '資料齊全'
                    }
                }
                this.form.remark = this.remark
                this.form.is_pass = val
                this.$ajax({
                    method: 'post',
                    url: this.$api.fundSubscriptionExamine,
                    data:this.form
                    // data: {
                    //     approval_person:this.param.approval_person,
                    //     approval_person_id:this.param.approval_person_id,
                    //     review_nodes:this.param.review_nodes,
                    //     type:this.param.type,
                    //     id:this.param.id,
                    //     remark:this.remark
                    // }
                }).then(res => {
                    if (res.data.qmiscode === 1000) {
                        this.$emit('child')
                    } else {
                        this.$message.warning(res.data.qmismsg)
                    }
                })
            },
            resetting(){
                this.form={
                    fund_name_cn:'',                
                    fund_name_en:'',                  
                    fund_code:'',                  
                    fund_type:'',                   
                    currency:'',                    
                    risk_rating:'',               
                    latest_price:'',                  
                    initial_amount:'',                 
                    subsequent_investment_amount:'',                
                    min_holding_amount:'',                 
                    min_redemption_amount:'',                
                    complex_product:'',                 
                    dividend_distribution_method:'',                    
                    dividend_frequency:'',                 
                    estimated_coupon_rate:'',                 
                    three_yrs_risk_return_ratio:'',                
                    sharpe_ratio:'',                    
                    year_to_date_returns:'',                   
                    last_three_mths_returns:'',                
                    last_one_mth_returns:'',                 
                    cumulative_performance:'',                 
                    management_fee:'',                
                    issue_date:'',
                    fund_factsheet:'',
                    fund_factsheet_en:'',
                    
                }
            },
			handokfn(val){
                /**
                 * val : 1=保存，2=提交
                 */
                //  return
                // 必填项校验
                if (!this.form.fund_name_cn) {
                    this.obj.falg1 = true
                    return
                }
                if (!this.form.fund_name_en) {
                    this.obj.falg2 = true
                    return
                }
                if (!this.form.fund_code) {
                    this.obj.falg3 = true
                    return
                }
                if (this.form.fund_type =='') {
                    this.obj.falg4 = true
                    return
                }
                if (this.form.currency =='') {
                    this.obj.falg5 = true
                    return
                }
                if (this.form.risk_rating=='') {
                    this.obj.falg6 = true
                    return
                }
                if (!this.form.latest_price) {
                    this.obj.falg7 = true
                    return
                }
                if (!this.form.initial_amount) {
                    this.obj.falg8 = true
                    return
                }
                if (!this.form.subsequent_investment_amount) {
                    this.obj.falg9 = true
                    return
                }
                if (!this.form.min_holding_amount) {
                    this.obj.falg10 = true
                    return
                }
                if (!this.form.min_redemption_amount) {
                    this.obj.falg11 = true
                    return
                }
                if (this.form.complex_product=='') {
                    this.obj.falg12 = true
                    return
                }
                if (this.form.dividend_distribution_method=='') {
                    this.obj.falg13 = true
                    return
                }
                if (this.form.dividend_frequency=='') {
                    this.obj.falg14 = true
                    return
                }
                if (!this.form.management_fee) {
                    this.obj.falg15 = true
                    return
                }
                if (!this.form.issue_date) {
                    this.obj.falg16 = true
                    return
                }

                if (!this.form.subscription_frequency) {
                    this.obj.falg17 = true
                    return
                }
                if (!this.form.authorized_product) {
                    this.obj.falg18 = true
                    return
                }
                if (!this.form.valuation_date) {
                    this.obj.falg19 = true
                    return
                }

                this.form.token = this.$store.state.token
                let url
                if (val == 1) {
                    url = this.$api.saveFund
                }else{
                    url = this.$api.addFund
                }
                this.$ajax({
                    method: 'post',
                    url: url,
                    headers: {
                        token: this.$store.state.token,
                    },
                    data: this.form
                }).then(res => {
                    console.log(res.data)
                    if (res.data.qmiscode == 1000) {
                        App.oTool.successT(res.data.qmismsg);
                        this.resetting()
                        this.$emit('child')
                    } else {
                        App.oTool.warningT(res.data.error);
                    }
                })
			},
			savefn() {
                this.$emit('child', 0)
                this.resetting()
			},
            handleOk(){
			},
            handleCancel(){
				this.$emit('child', 0)
                this.resetting()
			},

		}
	}
</script>
<style>
    input[type=number]::-webkit-inner-spin-button, 
    input[type=number]::-webkit-outer-spin-button { 
        -webkit-appearance: none; 
        margin: 0; 
    }
    .border_red{
        border-color: red !important;
    }
    .border_red .ant-input{
        border-color: red !important;
    }
    .border_red .ant-select-selection{
        border-color: red !important;
    }
    .border_red .ant-calendar-picker-input{
        border-color: red !important;
    }
</style>
<style scoped>
    .table_flex_left{
        width: 90% !important;
    }
    .table_flex{
        display: flex;
        align-items: center;
        width: 100%;
        font-size: 0.8rem;
    }
    .table_bottom{
        margin-bottom: 0.7rem;
    }
    .table_div_left{
        flex-shrink: 0;
        width: 6.5rem;
    }
    .table_div_right{
        flex-shrink: 0;
        width: 9.5rem;
    }
	#handitemedit1 .tabelMoreFzView .tabelMoreFzViewIn {
		background-color: #fff;
		padding: 0.7rem 0;
		border-radius: 4px;
		overflow: hidden;
	}

	#handitemedit1 .tabelMoreFzView .tabelMoreFzViewIn .tabelMoreFzViewInList {
		padding: 0.5rem 0;
		border-bottom: 1px #f3f3f3 solid;
		display: flex;
		align-items: flex-start;
	}

	#handitemedit1 .tabelMoreFzView .tabelMoreFzViewIn .tabelMoreFzViewInList:last-child {
		border: none;
	}

	#handitemedit1 .tabelMoreFzView .tabelMoreFzViewIn .tabelMoreFzViewInList .left {
		width: 24%;
		color: #000;
		font-size: 0.8rem;
	}

	#handitemedit1 .center {
		/* height: 1.7rem;
		    line-height: 1.7rem; */
	}

	#handitemedit1 .tabelMoreFzView .tabelMoreFzViewIn .tabelMoreFzViewInList .center {
		font-size: 0.8rem;
		width: calc(70% - 2rem);
		color: #000;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	#handitemedit1 .tabelMoreFzView .tabelMoreFzViewIn .tabelMoreFzViewInList img {
		width: 1.2rem;
		height: 1.2rem;
		margin: auto 0;
		margin-left: auto;
	}
</style>
<style lang="scss">
#main-handhomes{
		.ant-select-selection{
			color: #000;
			background-color: #fff;
		}
		 .ant-input-disabled {
		    color: #000;
		    background-color: #fff;
		}
		.has-error .ant-form-explain, .has-error .ant-form-split{
			display: none;
		}
		.ant-form-inline .ant-form-item-with-help {
		    margin-bottom: 0;
		}
		.ant-form label{
			font-size: .8rem;
		}
		.ant-modal-header, .ant-modal-body{
			border-radius:0 !important;
		}
		
		 .ant-modal-header, .ant-modal-body{
			background-color: #e5e5e5 !important;
			padding: 1rem;
			padding-top: .7rem;
		}
		
		.main-hand-title{
			position: absolute;
			top: 0;
			left: 0;
			div{
				font-size: 1rem;
				padding: .8rem 1rem .2rem 1rem;
				background-color:  #e5e5e5;
			}
		}
		
		.wland{
			display: inline-block;
			width: 7rem;
			padding: .4rem 0 .6rem;
			text-align: center;
			background-color: #fff;
			color: #000;
			border-top: .2rem solid #e99c00;
			border-right: 1px solid #e5e5e5;
			font-size: .8rem;
		}
		
		.gland{
			display: inline-block;
			width: 7rem;
			padding: .6rem 0;
			text-align: center;
			background-color: #0c8b97;
			color: #fff;
			font-size: .8rem;
			border-right: 1px solid #e5e5e5;
		}
	}
	
	#tubody-mainsk1>div{
		padding: 1px 0;
	}
	
	#tubody-mainsk1{
		background-color: #fff;
		.main-mybody{
			padding: .5rem 1.5rem 0;
			overflow-y: auto;
			min-height: 12rem;
			max-height: 30rem;
		}
		
		.ant-empty-normal{
				margin: 7rem 0;
		}
		
		.main-wid{
			width: 85%;
			height: 1px;
			border-top: .5px solid #d8d8d8;
			margin: 1rem 0;
		}
		
		.ant-col {
			font-size: .8rem;
			color: #000;
			margin: .2rem 0;
		}
		
		.btn{
			cursor: pointer;
			width: 6rem;
			height: 2rem;
			font-size: 0.8rem;
			color: #fff;
			border: 0;
			border-radius: 5px;
			text-align: center;
			line-height: 2rem;
			background-color: #0c8b97;
			margin: 1rem;
		}
		.btn1 {
			cursor: pointer;
			width: 5rem;
			height: 2rem;
			font-size: .8rem;
			color: #fff;
			border: 0;
			/* border-radius: 5px; */
			margin: 0 1rem;
		}
		.btnx {
			background-color: #0c8b97;
		}
		
		.btn2 {
			background-color: #f48d28;
		}
		
		.warp_daochu{
			border-top: 1px solid rgb(232, 232, 232);
			display: flex;
			justify-content: space-between;
			padding: 1rem .5rem ;
		
			div{
				font-size: .7rem;
			}
		}
	}
	#on-center {
		.ant-form-item-label {
			margin-top: 1.5rem;
		}
	}

	#handitemedit1 {

		.ant-row,
		.ant-calendar-picker {
			width: 100%;
		}

		.ant-form-item-label {
			width: 15% !important;
		}

		.ant-form-item-control-wrapper {
			width: 70% !important;

			.wart-t {
				width: 100%;
			}
		}

		.ant-calendar-picker-input {
			width: 100%;
		}

		.myright {
			.ant-form-item-label {
				width: 30% !important;
				padding-left: 3.5%;
			}
		}

		.warp_long {
			width: 50%;
			display: inline-block;

			.ant-form-item-label {
				width: 30% !important;
			}

			.ant-form-item-control-wrapper {
				width: 60% !important;

			}
		}

		.texright {
			text-align: right;
			// margin-left: 4%;
		}
	}
</style>
